// extracted by mini-css-extract-plugin
module.exports = {"spaceWrapper":"StreamSalesReportTable_spaceWrapper__1fKDi"};